module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-700.0017dad2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-700.ttf
// module id = 484
// module chunks = 0